import { Action } from 'redux';
import { Dispatch } from 'react-redux';
import { SWODispatchViewModel, StatusCountViewModel } from '@models/ServiceWorkOrder';
import { PageViewModel } from '@models/common.models';
import { swoService } from '@services/ServiceWorkOrderService';
import { toast } from 'react-toastify';
import { ToastComponent, ToastType } from '@common/components';
import * as React from 'react';
import { ToastOptions } from '@common/components/toast/toast';
import { ServiceWorkOrderSearchViewModel } from '@models/ServiceWorkOrder';

export enum DispatchActionType {
  SearchDispatchListStart = 'SearchDispatchListStart',
  SearchDispatchListSuccess = 'SearchDispatchListSuccess',
  SearchDispatchListFailure = 'SearchDispatchListFailure',

  GetStatusCountStart = 'GetStatusCountStart',
  GetStatusCountSuccess = 'GetStatusCountSuccess',
  GetStatusCountFailure = 'GetStatusCountFailure',

  SWOOwnershipStart = 'SWOOwnershipStart',
  SWOOwnershipSuccess = 'SWOOwnershipSuccess',
  SWOOwnershipFailure = 'SWOOwnershipFailure'
}

/***** Search Dispatch List *****/
export interface SearchDispatchListStartAction extends Action {
  readonly type: DispatchActionType.SearchDispatchListStart;
  readonly query: string | null;
}
export interface SearchDispatchListSuccessAction extends Action {
  readonly type: DispatchActionType.SearchDispatchListSuccess;
  readonly pageNumber: number;
  readonly pageSize: number;
  readonly orderBy: string;
  readonly result: PageViewModel<ServiceWorkOrderSearchViewModel>;
}

export interface SearchDispatchListFailureAction extends Action {
  readonly type: DispatchActionType.SearchDispatchListFailure;
  readonly error: string;
}

/***** Get Status Count *****/
export interface GetStatusCountStartAction extends Action {
  readonly type: DispatchActionType.GetStatusCountStart;
}

export interface GetStatusCountSuccessAction extends Action {
  readonly type: DispatchActionType.GetStatusCountSuccess;
  readonly statusCount: StatusCountViewModel;
}

export interface GetStatusCountFailureAction extends Action {
  readonly type: DispatchActionType.GetStatusCountFailure;
  readonly error: string;
}

/***** SWO Ownership *****/

export interface SWOOwnershipStartAction extends Action {
  readonly type: DispatchActionType.SWOOwnershipStart;
}

export interface SWOOwnershipSuccessAction extends Action {
  readonly type: DispatchActionType.SWOOwnershipSuccess;
  readonly swo: ServiceWorkOrderSearchViewModel;
}

export interface SWOOwnershipFailureAction extends Action {
  readonly type: DispatchActionType.SWOOwnershipFailure;
  readonly error: string;
}

/***** SWO Ownership *****/

export function swoOwnership(id: number, release?: boolean) {
  return async (dispatch: Dispatch<DispatchActionType>) => {
    dispatch(swoOwnershipStart());
    try {
      const swo = await swoService.swoOwnershipChange(id, release);

      return dispatch(swoOwnershipSuccess(swo));
    } catch (e) {
      return dispatch(swoOwnershipFailure(e));
    }
  };
}

export function swoOwnershipStart(): SWOOwnershipStartAction {
  return {
    type: DispatchActionType.SWOOwnershipStart
  };
}

export function swoOwnershipSuccess(swo: ServiceWorkOrderSearchViewModel): SWOOwnershipSuccessAction {
  return {
    type: DispatchActionType.SWOOwnershipSuccess,
    swo: swo
  };
}

export function swoOwnershipFailure(error: string): SWOOwnershipFailureAction {
  toast.error(<ToastComponent type={ToastType.Error} message={error.toString()} />, ToastOptions.Error);
  return {
    type: DispatchActionType.SWOOwnershipFailure,
    error: error
  };
}

/***** Search Dispatch List *****/
export function searchDispatchList(
  query: string | null,
  pageSize: number,
  pageNumber: number,
  orderBy: string,
  orderDirection: string,
  priority?: string,
  trade?: string
) {
  return async (dispatch: Dispatch<SWODispatchViewModel>) => {
    dispatch(searchDispatchListStart(query));
    try {
      const result: PageViewModel<ServiceWorkOrderSearchViewModel> = await swoService.search(
        pageNumber,
        pageSize,
        orderBy,
        orderDirection,
        query ? query : undefined,
        undefined,
        true,
        true,
        undefined,
        priority,
        trade
      );
      /*
      let result: PageViewModel<ServiceWorkOrderSearchViewModel> = await swoService.searchSWO(
        query,
        pageSize,
        pageNumber,
        orderBy,
        orderDirection,
        false,
        true
      );
      */
      dispatch(searchDispatchListSuccess(pageNumber, pageSize, orderBy, result!));
    } catch (e) {
      dispatch(searchDispatchListFailure(e.toString()));
    }
  };
}
export function searchDispatchListStart(query: string | null): SearchDispatchListStartAction {
  return {
    type: DispatchActionType.SearchDispatchListStart,
    query: query
  };
}
export function searchDispatchListSuccess(
  pageNumber: number,
  pageSize: number,
  orderBy: string,
  result: PageViewModel<ServiceWorkOrderSearchViewModel>
): SearchDispatchListSuccessAction {
  return {
    type: DispatchActionType.SearchDispatchListSuccess,
    pageNumber: pageNumber,
    pageSize: pageSize,
    orderBy: orderBy,
    result: result
  };
}
export function searchDispatchListFailure(error: string): SearchDispatchListFailureAction {
  toast.error(<ToastComponent type={ToastType.Error} message={error.toString()} />, ToastOptions.Error);
  return {
    type: DispatchActionType.SearchDispatchListFailure,
    error: error
  };
}

/***** Get Status Count *****/

export function getStatusCount() {
  return async (dispatch: Dispatch<StatusCountViewModel>) => {
    dispatch(getStatusCountStart());
    try {
      let result: StatusCountViewModel = await swoService.getStatusCount();
      dispatch(getStatusCountSuccess(result));
    } catch (e) {
      dispatch(getStatusCountFailure(e.toString()));
    }
  };
}
export function getStatusCountStart(): GetStatusCountStartAction {
  return {
    type: DispatchActionType.GetStatusCountStart
  };
}
export function getStatusCountSuccess(statusCount: StatusCountViewModel): GetStatusCountSuccessAction {
  return {
    type: DispatchActionType.GetStatusCountSuccess,
    statusCount: statusCount
  };
}
export function getStatusCountFailure(error: string): GetStatusCountFailureAction {
  toast.error(<ToastComponent type={ToastType.Error} message={error.toString()} />, ToastOptions.Error);
  return {
    type: DispatchActionType.GetStatusCountFailure,
    error: error
  };
}



// WEBPACK FOOTER //
// ./src/service-work-order/dispatch/dispatch.actions.tsx